import { useQuery } from "@tanstack/react-query";
import adminApiClient, { ClockSettingsDistributionResponse } from "api/admin";

export default function useClockSettingsDistribution(fromVersion?: number) {
  return useQuery<ClockSettingsDistributionResponse>({
    queryKey: ["clockSettingsDistribution", fromVersion],
    queryFn: () => adminApiClient.getClockSettingsDistribution(fromVersion),
  });
}
